/**
 * @module initWebSocket 初始化
 * @module websocketonopen 连接成功
 * @module websocketonerror 连接失败
 * @module websocketclose 断开连接
 * @module resetHeart 重置心跳
 * @module sendSocketHeart 心跳发送
 * @module reconnect 重连
 * @module sendMsg 发送数据
 * @module websocketonmessage 接收数据
 * @module test 测试收到消息传递
 * @description socket 通信
 * @param {any} url socket地址
 * @param {any} websocket websocket 实例
 * @param {any} heartTime 心跳定时器实例
 * @param {number} socketHeart 心跳次数
 * @param {number} HeartTimeOut 心跳超时时间
 * @param {number} socketError 错误次数
 */
import { getToken } from '@/utils/auth';
import { ElNotification } from 'element-plus';
import useNoticeStore from '@/store/modules/notice';
import request from '@/utils/request';
import useUserStore from '@/store/modules/user';

export enum ReadStatus {
  READ = 0, // 已读
  UNREAD = 2 // 未读
}

export enum Types {
  SYS_MESSAGE = 0, // 系统消息
  OTHER_MESSAGE = 9 // 其他消息
}
let socketUrl: any = ''; // socket地址
const sendUrl: any = '/resource/ws/socketSend';
const cacheUrl: any = '/resource/ws/socketCache';
let websocket: any = null; // websocket 实例
let heartTime: any = null; // 心跳定时器实例
let socketHeart = 0 as number; // 心跳次数
const HeartTimeOut = 10000; // 心跳超时时间 10000 = 10s
let socketError = 0 as number; // 错误次数

// 初始化socket
export const initWebSocket = (url: any) => {
  if (import.meta.env.VITE_APP_WEBSOCKET === 'false') {
    return;
  }
  socketUrl = url;
  console.log(url);
  // 初始化 websocket
  websocket = new WebSocket(url + '?Authorization=Bearer ' + getToken() + '&clientid=' + import.meta.env.VITE_APP_CLIENT_ID);
  websocketonopen();
  websocketonmessage();
  websocketonerror();
  websocketclose();
  sendSocketHeart();
  return websocket;
};

// socket 连接成功
export const websocketonopen = () => {
  websocket.onopen = function () {
    console.log('连接 websocket 成功');
    resetHeart();
  };
};

// socket 连接失败
export const websocketonerror = () => {
  websocket.onerror = function (e: any) {
    console.log('连接 websocket 失败', e);
  };
};

// socket 断开链接
export const websocketclose = () => {
  // const messageList: any[] = [];
  // state.notices.forEach((item) => {
  //   // 断开链接的时候，所有消息存进数据库，未读消息存进redis
  //   if (!item.read) {
  //     messageList.push(item.message);
  //   }
  // });
  // if (messageList.length != 0) {
  //   const data = {
  //     sessionKey: userStore.userId,
  //     message: messageList
  //   };
  //   request({
  //     url: cacheUrl,
  //     method: 'post',
  //     data: data
  //   }).then((r) => {
  //     console.log(r);
  //   });
  // }
  websocket.onclose = function (e: any) {
    console.log('断开连接', e);
  };
};

// socket 重置心跳
export const resetHeart = () => {
  socketHeart = 0;
  socketError = 0;
  clearInterval(heartTime);
  sendSocketHeart();
};

// socket心跳发送
export const sendSocketHeart = () => {
  heartTime = setInterval(() => {
    // 如果连接正常则发送心跳
    if (websocket.readyState == 1) {
      // if (socketHeart <= 30) {
      websocket.send(
        JSON.stringify({
          type: 'ping'
        })
      );
      socketHeart = socketHeart + 1;
    } else {
      // 重连
      reconnect();
    }
  }, HeartTimeOut);
};

// socket重连
export const reconnect = () => {
  if (socketError <= 2) {
    clearInterval(heartTime);
    initWebSocket(socketUrl);
    socketError = socketError + 1;
    // eslint-disable-next-line prettier/prettier
        console.log('socket重连', socketError);
  } else {
    // eslint-disable-next-line prettier/prettier
        console.log('重试次数已用完');
    clearInterval(heartTime);
  }
};

// socket 发送数据
export const sendMsg = (data: any) => {
  // websocket.send(data);
  request({
    url: sendUrl,
    method: 'post',
    data: data
  }).then((r) => {
    console.log(r);
  });
};

// socket 接收数据
export const websocketonmessage = () => {
  websocket.onmessage = function (e: any) {
    if (e.data.indexOf('heartbeat') > 0) {
      resetHeart();
    }
    if (e.data.indexOf('ping') > 0) {
      return;
    }
    // 把接收到的内容转成json格式
    const jsonMessage = JSON.parse(e.data);
    const { addNotice } = useNoticeStore();
    const userStore = useUserStore();
    addNotice({
      fromUserId: jsonMessage.fromUserId,
      fromUserIp: jsonMessage.fromUserIp,
      toUserId: jsonMessage.toUserId,
      toUserIp: userStore.userIp,
      type: jsonMessage.type,
      message: jsonMessage.message,
      readStatus: ReadStatus.UNREAD,
      sendTime: jsonMessage.sendTime
    });
    if (jsonMessage.type == '0') {
      ElNotification({
        title: '系统消息',
        message: jsonMessage.message,
        type: 'success',
        duration: 3000
      });
    } else {
      ElNotification({
        title: '其他消息',
        message: jsonMessage.message,
        type: 'success',
        duration: 3000
      });
    }
    return e.data;
  };
};
